import RaydiumLogo from "@/assets/icons/raydium-logo.svg"
import Identicon from "@/components/base/Identicon"
import { RAY } from "@renec-foundation/relend-adapter"
import { Keypair } from "@solana/web3.js"
import Image, { StaticImageData } from "next/image"

const tokenLogos: { [key: string]: StaticImageData } = {
  [RAY]: RaydiumLogo,
}

export enum LOGO_SIZES {
  LG = 32,
  MD = 24,
  SM = 20,
}

export const getTokenLogo = (
  symbol?: string,
  item: { logo?: string | null | StaticImageData } = {},
): StaticImageData | null => {
  return tokenLogos[symbol ?? ""] || item.logo
}

export const getTokenLogoDisplay = (
  symbol?: string,
  item: { logo?: string | null | StaticImageData; mintAddress?: string } = {},
  logoSize: LOGO_SIZES = LOGO_SIZES.MD,
) => {
  const logo = getTokenLogo(symbol, item)
  if (logo) {
    return (
      <Image src={logo} alt={symbol || "Token"} width={logoSize} height={logoSize} style={{ borderRadius: "100%" }} />
    )
  }
  return (
    <Identicon
      address={item?.mintAddress || Keypair.generate().publicKey.toBase58()}
      style={{ width: 32, height: 32, borderRadius: "100%" }}
    />
  )
}

export default tokenLogos
